module.exports = __webpack_public_path__ + "static/img/dash.ea49a325.svg";